module.exports = __webpack_public_path__ + "static/media/dummy-avatar.a57f6a0b.svg";